import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { ROUTE } from "../../constant/routes";
import { STORAGE } from "../../constant/storages";
import { ApiserviceService } from "../../httpservice/apiservice.service";
import { AppService } from "../../services/app.service";
import { TEXT } from "../../text_control";
import { errMsg } from "../../text_control/error-msg";
import { BTN } from "../../text_control/text_button";
import { TEXT_TABLE } from "../../text_control/text_table";
import { _deleteStorage, _getStorage, _setStorage } from "../../utils/local-storage";

@Component({
  selector: "app-replace",
  templateUrl: "./replace.component.html",
  styleUrls: ["./replace.component.scss"],
})
export class ReplaceComponent implements OnInit {
  taxinvoice = "123456";
  selectDocument = "TIVC01";
  selectTypeAbb = "0";
  other: any = "";
  text: any;
  textBTN: any;
  textTB: any;

  dataother = [
    {
      otheradd: "ชื่อและที่อยู่ไม่ถูกต้อง",
    },
    {
      otheradd: "ชื่อเอกสารไม่ถูกต้อง (ยกตัวอย่าง)",
    },
    {
      otheradd: "อื่นๆโปรดระบุ",
    },
  ];
  datatax: any;
  Active = 2;
  taxNumber: any = "";
  numberAbb: any = "";
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";
  constructor(
    public apiservice: ApiserviceService,
    public route: Router,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public storeg: Storage,
    public appService: AppService,
    private router: ActivatedRoute
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE

    _deleteStorage(STORAGE.DATA_SEARCH_REPLACE)
    _deleteStorage(STORAGE.DATA_PREVIEW_REPLACE)
    _deleteStorage(STORAGE.DATA_CHECK_REPLACE)
  }

  ngOnInit() { }
  ionViewDidEnter() {
    this.router.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 2;
      }
    });
    this.taxNumber = "";
    this.numberAbb = "";
    this.other = "";
    this.selectDocument = "TIVC01";
  }

  showother = false;
  other1 = "";

  checkselect(e) {
    console.log(e.otheradd);
    let other = String(this.other);
    this.other = e.otheradd;
    if (this.other != "") {
      this.selectDocument = "TIVC99";
      console.log(this.selectDocument);
    }
    if (e.otheradd === "อื่นๆโปรดระบุ") {
      this.showother = true;
    } else {
      this.showother = false;
    }
  }
  checkradio1() {
    this.other = "";
    this.showother = false;
  }
  checkradio2() {
    this.other = "";
    this.showother = false;
  }
  checktax(e) {
    this.taxNumber = e.target.value.match(/[0-9]*/)[0];
  }
  checkperson3() {
    this.other = "";
    this.showother = true;
  }

  async searchtaxinvoice() {
    console.log("other...", this.other);
    let isConfirm: boolean = false;
    let apiUrl = this.apiservice.apiUrl;
    let taxNumber = String(this.taxNumber);
    let other = String(this.other);

    if (!isConfirm) {
      if (this.selectDocument === undefined) {
        this.ErrorMsg(errMsg.errorSearchReplaceEmpty)
      } else if (this.selectDocument === "TIVC99") {
        if (other === "") {
          this.ErrorMsg(errMsg.errorSearchReplaceOther)
        } else if (taxNumber === "") {
          this.ErrorMsg(errMsg.errorReplaceTaxNumberEmpty)
        } else if (this.numberAbb === "") {
          this.ErrorMsg(errMsg.errorReplaceNumberAbbEmpty)
        } else {
          isConfirm = true;
        }
      } else if (taxNumber === "") {
        this.ErrorMsg(errMsg.errorReplaceTaxNumberEmpty)
      } else if (this.numberAbb === "") {
        this.ErrorMsg(errMsg.errorReplaceNumberAbbEmpty)
      } else {
        isConfirm = true;
      }
    }

    if (isConfirm) {
      let datatax = {
        selectDocument: this.selectDocument,
        other: other,
      };
      const req = {
        taxinvoice_no: this.taxNumber,
        userBu: this.userBu,
        userLoc: this.userLoc,
        userRole: this.userRole,
        userSource: this.userSource,
        receiptDate: "",
        user_id: this.userID,
        ...(this.numberAbb && {
          abbNo: this.numberAbb,
          isTpNo: this.selectTypeAbb === "0" ? true : false,
        })
      };

      console.log("========= req search replace =========", req);

      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.searchTaxinvoice, req)
          .then(async (res: any) => {
            this.datatax = res.taxinvoice_detail;
            const data = {
              datatax: this.datatax,
              taxnumber: datatax,
            };

            console.log("========== res search replace ==========", res);
            if (this.datatax.statusCode === 200) {
              _setStorage(STORAGE.DATA_SEARCH_REPLACE, data)
              if (this.Active === 2) {
                this.route.navigate([ROUTE.REPLACE_SELECT]);
              } else {
                this.route.navigate([ROUTE.REPLACE_SELECT], {
                  queryParams: { noName: "no_replace", selectedIndex: "4" },
                });
              }
            } else if (this.datatax.statusCode === 204) {
              this.ErrorMsg(this.datatax.statusMessage);
            } else {
              this.ErrorMsg(this.datatax.statusMessage);

            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    setTimeout(async () => {
      this.taxNumber = "";
      this.other = "";
      this.selectDocument = "TIVC01";
      this.selectTypeAbb = "0";
      this.numberAbb = "";
      await loading.dismiss();
    }, 2000);
  }
}
